import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(VApp,[_c('Toolbar'),_c(VMain,[_c('Content')],1),_c('Footer'),_c('ContratoDialog'),_c('AssinaturaDialog')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }